import { render, staticRenderFns } from "./ItemDelete.vue?vue&type=template&id=21d5768e&scoped=true&"
import script from "./ItemDelete.vue?vue&type=script&lang=js&"
export * from "./ItemDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d5768e",
  null
  
)

export default component.exports